import * as React from 'react'
import { Form } from 'antd'
import { isNil, set, get } from 'lodash'
import { useImmer } from 'use-immer'
import { useDebouncedCallback } from 'use-debounce'
import { DEBOUNCE } from 'helpers/utils'
import { createDropdownRender } from 'helpers/formViews'
import { showError } from 'helpers/errors'
import taskTypes from 'options/tasks/taskTypes'
import { t } from 'helpers/i18n'
import Modal from 'elements/Modal'
import Select, { Option, getOptionProps } from 'elements/Select'

function Component(props) {
  const { getAssets, getTaskItems } = props

  const [state, updateState] = useImmer({ visible: true })

  function setState(path, value) {
    updateState((draft) => {
      set(draft, path, value)
    })
  }

  async function fetchAssets(search) {
    try {
      const response = await getAssets({
        search,
        assetIds: state.assetId ? [state.assetId] : undefined,
      })

      setState('assets', response.value.data)
    } catch (error) {
      showError({ error })
    }
  }

  async function handleOk() {
    try {
      setState('loading', true)

      const taskItems = await getTaskItems({
        taskType: taskTypes.ScheduledJob,
        assetId: state.assetId,
      }).then((r) => get(r, 'value.data.items', []))

      setState('visible', false)

      window.setTimeout(() => props.onCopy?.(taskItems), 500)
    } catch (error) {
      showError({ error })
    } finally {
      setState('loading', false)
    }
  }

  function handleCancel() {
    setState('visible', false)

    window.setTimeout(props.onCancel, 500)
  }

  React.useEffect(() => {
    fetchAssets()
  }, [])

  const searchAssets = useDebouncedCallback((search) => fetchAssets(search), DEBOUNCE)

  return (
    <Modal
      title={t('copySchedule')}
      visible={state.visible}
      okText={t('copy')}
      onOk={handleOk}
      okButtonProps={{ loading: state.loading, disabled: isNil(state.assetId) }}
      onCancel={handleCancel}
    >
      <p>{t('copyScheduleDescription')}</p>
      <Form.Item label={t('asset')} colon={false}>
        <Select
          onChange={(value) => setState('assetId', value)}
          value={state.assetId}
          dropdownRender={createDropdownRender(state.assets)}
          onSearch={searchAssets}
          placeholder={t('select')}
          showSearch
        >
          {(state?.assets?.items ?? []).map((each) => (
            <Option key={each.id} value={each.id}>
              <span {...getOptionProps(each)}>{each.displayName}</span>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Modal>
  )
}

export default Component
